module.exports = __webpack_public_path__ + "static/media/master.258f870d.png";